import { SerializedEditorState } from "lexical";
import { RichContentDocumentSchema } from "src/types/messages/content";
import { z } from "zod";

// This is a no-op stub to add typing to the MessageContent type.
function mockIsSerializedEditorState(x: any): x is SerializedEditorState {
  return true;
}

export const MessageTemplateContentSchema = RichContentDocumentSchema.extend({
  language_name: z.string(),
  error_message: z.string().optional(),
  /** `message_template_rich_content.content_id` when this row was loaded from the server (for cleanup on save). */
  content_id: z.string().optional(),
});

export type MessageTemplateContent = z.infer<
  typeof MessageTemplateContentSchema
>;

export const MessageTranslationSchema = z.object({
  error_message: z.string().optional(),
  language: z.string(),
  language_name: z.string(),
  subject: z.string().optional(),
  lexical: z.any().refine(mockIsSerializedEditorState).optional(),
  smsLexical: z.any().refine(mockIsSerializedEditorState).optional(),
});

export type MessageTranslationType = z.infer<typeof MessageTranslationSchema>;

export const PreviewDrawerFormSchema = z.object({
  messages: z.array(MessageTranslationSchema),
});

export type PreviewDrawerFormType = z.infer<typeof PreviewDrawerFormSchema>;

export const AutomaticMessageFormSchema = z.object({
  enabled: z.boolean(),
  messages: z.array(MessageTemplateContentSchema),
  /** Persisted rich content document ids removed in the UI; deleted on successful save. */
  removedPersistedRichContentIds: z.array(z.string()).optional(),
});

export type AutomaticMessageFormType = z.infer<
  typeof AutomaticMessageFormSchema
>;
